









import { Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class ProjectIcon extends Vue {
  @Prop(Number) public avatarSize!: number;
  @Prop(String) public avatarText!: string;

  // TODO: プロジェクトを登録する方法が未確定なので、一旦の処置。現状色が逐一変わってしまうので、プロジェクト登録の際に色も確定させること。(宮崎)
  /** プロジェクトアイコンの色をランダムに決めるメソッド */
  private getRandomColor(): string {
    const r = Math.round(Math.random() * 255);
    const g = Math.round(Math.random() * 255);
    const b = Math.round(Math.random() * 255);
    const randomColor = `rgb(${r}, ${g}, ${b})`;
    return randomColor;
  }
}
